/**
 * useAIAgent Hook
 *
 * Separated from AIAgentContext.tsx for React Fast Refresh compatibility.
 * This prevents HMR invalidation loops when the context file is modified.
 */
import { useContext } from 'react';
import { AIAgentContext, AIAgentContextType } from './AIAgentContext';

export const useAIAgent = (): AIAgentContextType => {
  const context = useContext(AIAgentContext);
  if (!context) {
    throw new Error('useAIAgent must be used within AIAgentProvider');
  }
  return context;
};
